import i18next from 'i18next';

import { FormatWithThousandSeparator } from './numberFormat';

export function fillTranslationPlaceholders(template: string, values: string[]): string {
	let result = template;
	for (const val of values) {
		result = result.replace('%%', String(val));
	}
	return result;
}

export function formatChipsForBroadcast(value: unknown): string {
	const n = typeof value === 'number' ? value : Number(value);
	if (!Number.isFinite(n)) {
		return String(value ?? '');
	}
	return FormatWithThousandSeparator(n, { hideFractIfInteger: true });
}

/** Handles nested API payloads `{ data: { username, ... } }` and flat `{ username, ... }` from game broadcasts. */
export function extractGameBroadcastPayload(raw: unknown): Record<string, any> | null {
	if (!raw || typeof raw !== 'object') {
		return null;
	}
	const r = raw as Record<string, any>;
	if (r.data && typeof r.data === 'object' && typeof r.data.username === 'string') {
		return r.data as Record<string, any>;
	}
	if (typeof r.username === 'string') {
		return r;
	}
	return null;
}

/**
 * `tableName` is usually `table.name` (often just a number). `roomName` is `gameState.roomName`
 * so Macao vs Las Vegas is correct when the table label is numeric-only.
 */
export function buildWhiskeyTableLabel(
	tableName: string | undefined | null,
	roomName?: string | undefined | null,
): string {
	if (!tableName?.trim()) {
		return '';
	}
	const trimmed = tableName.trim();
	const roomLc = (roomName || '').toLowerCase();
	const parts = trimmed.split(/\s+/);
	if (parts.length >= 2) {
		const roomKey = `T_SITE_${parts[0].toUpperCase()}`;
		const roomLabel = String(i18next.t(roomKey, { defaultValue: parts[0] }));
		return `${roomLabel} ${parts.slice(1).join(' ')}`;
	}
	if (/^\d+$/.test(trimmed)) {
		if (roomLc.includes('macao')) {
			const room = i18next.t('T_SITE_MACAO', { defaultValue: 'Macao' });
			return `${room} #${trimmed}`;
		}
		if (roomLc.includes('vegas')) {
			const room = i18next.t('T_SITE_VEGAS', { defaultValue: 'Las Vegas' });
			return `${room} #${trimmed}`;
		}
		const tableWord = i18next.t('T_SITE_ACTIVE_TABLES_TABLE', { defaultValue: 'Table' });
		return `${tableWord} ${trimmed}`;
	}
	return trimmed;
}
